import { render } from "./BodaccTab.vue?vue&type=template&id=65c3814c"
import script from "./BodaccTab.vue?vue&type=script&lang=ts"
export * from "./BodaccTab.vue?vue&type=script&lang=ts"
script.render = render

export default script